<template>
  <div class="home">
    <pc v-if="isPC"/>
    <mobile v-else/>
  </div>
</template>

<script>
import mobile from '@/components/mobile'
import pc from '@/components/pc' 
import { mapState } from 'vuex'
export default {
  components: {
    mobile,
    pc
  },
  computed: {
    ...mapState([
      'isPC'
    ])
  }
}
</script>
